<script lang="typescript">
    import LensDetail from "./LensDetail.svelte";
    import { variantImages } from "../appData.js";
</script>

<LensDetail title="Anti-Reflection" images={variantImages.antiReflectPlus}>
    <div>
        <h2>The Advantages of Anti Reflective lenses are:</h2>
        <ul>
            <li>
                <strong>Ultra scratch resistance: </strong>Offering our best protection from
                scratches
            </li>
            <li>
                <strong>Anti-Static technology: </strong>The lenses attract less dust, so keep
                cleaner for longer
            </li>
        </ul>
    </div>
    <div>
        <h2>Who is it suitable for?</h2>
        <ul>
            <li>Most lifestyles including computer use, driving and sport</li>
            <li>
                This technologically advanced coating helps to significantly reduce reflections,
                giving you clearer vision by allowing 99.8% of available light through the lens and
                making it resistant to condensation.
            </li>
        </ul>
    </div>
</LensDetail>
